<header class="br-header">
  <div class="container-lg">
    <div class="header-top">
      <div class="header-logo">
        <img [src]="logo" alt="logo" /><span class="br-divider vertical"></span>
        <div class="header-sign">{{ signature }}</div>
      </div>
      <div class="header-actions">
        <div class="header-links dropdown" [ngClass]="{show: showLinks}">
          <button
            class="br-button circle small"
            [ngClass]="{active: showLinks}"
            type="button"
            data-toggle="dropdown"
            aria-label="Abrir Acesso Rápido"
            (click)="showLinks = !showLinks"
          >
            <i class="fas fa-ellipsis-v" aria-hidden="true"></i>
          </button>
          <div class="br-list">
            <div class="header">
              <div class="title">Acesso Rápido</div>
            </div>
            @for (l of links; track l.label) {
            <a class="br-item" href="javascript:void(0)">{{ l.label }}</a>
            }
          </div>
        </div>
        <span class="br-divider vertical mx-half mx-sm-1"></span>
        <div
          class="header-functions dropdown"
          [ngClass]="{'show': showFunctions}"
        >
          <button
            class="br-button circle small"
            [ngClass]="{active: showFunctions}"
            type="button"
            data-toggle="dropdown"
            aria-label="Abrir Funcionalidades do Sistema"
            (click)="showFunctions = !showFunctions"
          >
            <i class="fas fa-th" aria-hidden="true"></i>
          </button>
          <div class="br-list">
            <div class="header">
              <div class="title">{{ features?.title }}</div>
            </div>
            <div class="br-item" *ngFor="let feature of features?.links">
              <button
                class="br-button circle small"
                type="button"
                aria-label="Funcionalidade 1"
              >
                <i class="fas fa-chart-bar" aria-hidden="true"></i
                ><span class="text">{{ feature.label }}</span>
              </button>
            </div>
          </div>
        </div>
        <div class="header-search-trigger" *ngIf="searchBar">
          <button
            class="br-button circle"
            type="button"
            aria-label="Abrir Busca"
            data-toggle="search"
            data-target=".header-search"
            (click)="showSearchBar = !showSearchBar"
          >
            <i class="fas fa-search" aria-hidden="true"></i>
          </button>
        </div>
        @if (!isAuthenticated) {
        <div class="header-login">
          <div class="header-sign-in">
            <button
              class="br-sign-in small"
              type="button"
              data-trigger="login"
              (click)="startSession()"
            >
              <i class="fas fa-user" aria-hidden="true"></i
              ><span class="d-sm-inline">Entrar</span>
            </button>
          </div>
          <div class="header-avatar"></div>
        </div>
        }

        <app-profile></app-profile>
      </div>
    </div>
    <div class="header-bottom">
      <div class="header-menu">
        <div class="header-menu-trigger">
          <app-menu [logo]="logo" [title]="title"></app-menu>
        </div>
        <div class="header-info">
          <div class="header-title">{{ title }}</div>
          <div class="header-subtitle">{{ subtitle }}</div>
        </div>
      </div>
      <div
        class="header-search"
        [ngClass]="{active: showSearchBar}"
        *ngIf="searchBar"
      >
        <div class="br-input has-icon">
          <label for="searchbox-114">Texto da pesquisa</label>
          <input
            id="searchbox-114"
            type="text"
            placeholder="O que você procura?"
          />
          <button
            class="br-button circle small"
            type="button"
            aria-label="Pesquisar"
          >
            <i class="fas fa-search" aria-hidden="true"></i>
          </button>
        </div>
        <button
          class="br-button circle search-close ml-1"
          type="button"
          aria-label="Fechar Busca"
          data-dismiss="search"
          (click)="showSearchBar = !showSearchBar"
        >
          <i class="fas fa-times" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
</header>
